<!-- display-mobile-01 preview — publisher site, card carousel ad -->
<app-mobile-frame>
  <!-- START: Site header -->
  <div class="gs-site-header d-flex flex-row align-items-center justify-content-between" frameTop>
    <i class="bi bi-list"></i>
    <span class="gs-skel gs-skel-brand"></span>
    <i class="bi bi-search"></i>
  </div>
  <!-- END: Site header -->

  <div class="gs-page">
    <span *ngFor="let w of linesAbove" class="gs-skel gs-skel-line" [style.width.%]="w" aria-hidden="true"></span>

    <!-- START: Real ad -->
    <div class="gs-promo">
      <div class="gs-cards d-flex flex-row">
        <a
          *ngFor="let card of cards"
          class="gs-card d-flex flex-column"
          [href]="data.url || null"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="gs-card-image">
            <img [src]="card.image" alt="" />
          </span>
          <span class="gs-card-body d-flex flex-column">
            <span class="gs-card-title">{{ card.title }}</span>
            <!-- Rating and price: no template field, so they are static -->
            <span class="gs-stars">
              <i *ngFor="let _ of [0, 1, 2, 3, 4]" class="bi bi-star-fill"></i>
            </span>
            <span class="gs-card-price">Najbolja cijena</span>
            <span class="gs-card-cta">{{ ctaText }}</span>
          </span>
        </a>
      </div>

      <div class="gs-brand-row d-flex flex-row align-items-center">
        <span class="gs-logo"><img src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png" alt="" /></span>
        <div class="gs-brand-info">
          <a class="gs-long-headline" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
            {{ longHeadline }}
          </a>
          <div class="gs-brand-name">Valamar</div>
        </div>
        <i class="bi bi-info-circle gs-info"></i>
      </div>
    </div>
    <!-- END: Real ad -->

    <span *ngFor="let w of linesBelow" class="gs-skel gs-skel-line" [style.width.%]="w" aria-hidden="true"></span>
  </div>
</app-mobile-frame>
